import resolveConfig from "tailwindcss/resolveConfig";
import tailwindConfig from "../../tailwind.config.js";

const fullConfig = resolveConfig(tailwindConfig);
type ColorKey = keyof typeof fullConfig.theme.colors;

type ColorValue =
  | string
  | { [key: string]: string | { [key: string]: string } };

export const getColor = (colorKey: string): string | undefined => {
  const keys = colorKey.split("-") as [ColorKey, string?];
  let color: ColorValue = fullConfig.theme.colors[keys[0]];

  if (keys[1] && typeof color === "object") {
    if (keys[1] in color) {
      color = color[keys[1] as keyof typeof color];
    }

    if (
      typeof color === "object" &&
      keys[1] in color &&
      typeof color[keys[1]] === "object"
    ) {
      color = color[keys[1] as keyof typeof color];
    }
  }

  return typeof color === "string" ? color : undefined;
};
